import React from 'react';
import styled from 'styled-components';
import { colors } from 'src/components/base';
import { Column } from '@prisjakt/ui/list/variants';

export const SectionSeparator = styled.li.attrs({ role: 'presentation' })`
  border-bottom: 1px solid ${colors.borderLightGray};
`;

export const SectionList = styled(Column).attrs({
  styledComponentProps: { as: 'ul' },
  separator: <SectionSeparator />,
})`
  list-style: none;
  width: 100%;
`;

export const FilterSectionSeparator = styled(SectionSeparator).attrs({
  as: 'div',
})``;

export const FilterSectionButtonList = styled(SectionList).attrs({
  styledComponentProps: { as: 'div' },
  separator: <FilterSectionSeparator />,
})`
  width: 100%;
`;
